// ==========================================
//  Simplified Swatch Logic (Independent Colors + Sizes)
//  Colors: Always visible, <a> tags with variant URLs (no JS needed for navigation)
//  Sizes: Non-interactive display, visible on hover (CSS-driven)
// ==========================================

// Color swatches are <a> tags that navigate via native href.
// Since they're now inside the card-gallery (which itself is wrapped
// in a parent <a> link), we must stop the parent link from hijacking
// the swatch navigation.

function initSwatchCards() {
  document.querySelectorAll(".product-card:not(.swatches-initialized)").forEach(card => {
    card.classList.add("swatches-initialized");

    // Desktop: swatches inside the gallery overlay
    const desktopSwatches = card.querySelectorAll(".card-swatches-row .custom-swatch");
    // Mobile: swatches in the mobile container
    const mobileSwatches = card.querySelectorAll(".size-color-swatches_contanier .mobileswatch");

    [...desktopSwatches, ...mobileSwatches].forEach(swatch => {
      swatch.addEventListener("click", e => {
        // Stop the click from bubbling up to the parent <a> (gallery link)
        // and the product-card link
        e.stopPropagation();
        // Navigate to the swatch's own href
        if (swatch.href) {
          window.location.href = swatch.href;
        }
      });
    });
  });
}

initSwatchCards();
document.addEventListener("DOMContentLoaded", initSwatchCards);

const observer = new MutationObserver((mutations) => {
  let hasNewNodes = false;
  for (let i = 0; i < mutations.length; i++) {
    if (mutations[i].addedNodes.length > 0) {
      hasNewNodes = true;
      break;
    }
  }
  if (hasNewNodes) {
    initSwatchCards();
  }
});

observer.observe(document.body, { childList: true, subtree: true });